module.exports = {"id":"215199","name":"Rubén Botta","rating":"76","photo":"./data/images/photos/3/215199.png","club":{"name":"San Lorenzo","logo":"./data/images/clubs/SanLorenzo.png"},"positions":["MG","MD","AD","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenBotta0.json
// module id = 3728
// module chunks = 0